import Tracker from './Tracker'

class Tealium extends Tracker {
  resolveInit
  TEALIUM_LOADED_EVENT_TYPE = 'TealiumLoaded'

  async init() {
    const tealiumLoaded = new Event('TealiumLoaded')
    return new Promise((resolve) => {
      this.resolveInit = resolve
      this.onTealiumLoaded()

      const env = this.props.env
      const url = this.props.url?.[env]
      window.utag_data = window.utag_data ?? {}

      /* istanbul ignore next */
      !(function (a, b, c, d) {
        a = url
        b = document
        c = 'script'
        d = b.createElement(c)
        d.src = a
        d.type = 'text/java' + c
        d.async = true
        a = b.getElementsByTagName(c)[0]
        if (a) {
          a.parentNode.insertBefore(d, a)
        } else {
          b.body.appendChild(d)
        }
        d.handlerFlag = 0
        d.onreadystatechange = function () {
          if ((this.readyState === 'complete' || this.readyState === 'loaded') && !d.handlerFlag) {
            d.handlerFlag = 1
            document.dispatchEvent(tealiumLoaded)
          }
        }
        d.onload = function () {
          if (!d.handlerFlag) {
            d.handlerFlag = 1
            document.dispatchEvent(tealiumLoaded)
          }
        }
      })()
    })
  }

  /* istanbul ignore next */
  onTealiumLoaded() {
    document.addEventListener(
      this.TEALIUM_LOADED_EVENT_TYPE,
      () => {
        this.resolveInit()
      },
      false
    )
  }

  /* istanbul ignore next */
  event(event, firstLoad, ...args) {
    if (!(firstLoad && event === 'pageview')) {
      window.utag?.track(...args)
    }
  }
}

export default Tealium
